import React from 'react';
import { KBSelect, KBUserInput } from 'components';
import { SPACE_MEMBER_LOCATION_ROLES } from 'app/constants';

var MemberLocationRolesSettings = class extends React.Component {componentDidMount()
  {}render()

  {
    const { location_permission_settings, locations, locationsObj } = this.props;
    return (
      <div>
        {location_permission_settings.length > 0 &&
        location_permission_settings.map((json, index) => {
          let spaceMemberRoles = SPACE_MEMBER_LOCATION_ROLES;
          const locationIdField = json.location_id || {};
          const roleField = json.role || {};
          const enabledField = json.enabled || {};
          const rowKey = [
          locationIdField.value || locationIdField.name,
          roleField.value || roleField.name,
          index].
          filter(Boolean).
          join('-');

          return enabledField.value ?
          <div key={rowKey || index} style={{ position: 'relative' }}>
                <div className="kb-row kb-form-66">
                  <KBUserInput
              title="分店"
              placeholder="选择分店"
              className="kb-form-group kb-div-c39"
              field={locationIdField}
              isRequired={true}
              multi={false}
              users={locations}
              selectedUsers={[locationsObj[locationIdField.value]]} />

                  <KBSelect
              defaultValue=" "
              isRequiredR={true}
              className="kb-form-group kb-div-c39"
              titleClass="label-rt"
              title="角色"
              field={roleField}
              arrayData={spaceMemberRoles} />

                  {/*<KBSelect defaultValue=' ' isRequiredR={true} className='kb-form-group kb-div-48' titleClass='label-rt' title='激活' field={json.enabled} arrayData={LOCATION_ROLES_ENABLED}  />*/}
                </div>
                <i
            className="iconfont icon-delete hover-delete"
            style={{ position: 'absolute', top: 38, right: 0 }}
            onClick={() =>
            enabledField.onChange && enabledField.onChange(false)} />


              </div> :

          null;

        })}
      </div>);

  }};


export default MemberLocationRolesSettings;
